/**
 * Parses a date string as local date at noon to avoid timezone edge cases.
 * DatePicker works in local time, so we create local dates at noon (not midnight).
 *
 * @param dateString - Date string in YYYY-MM-DD format
 * @returns Date object parsed as local date at noon, or undefined if invalid/unexpected format
 */
const parseMemberDateOfBirthForPicker = (dateString: string | null): Date | undefined => {
  if (!dateString) return undefined;

  // Handle YYYY-MM-DD format - create local date at noon
  const yyyymmddMatch = dateString.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (yyyymmddMatch) {
    const [, year, month, day] = yyyymmddMatch;
    // Create at noon local time to avoid midnight timezone edge cases
    return new Date(parseInt(year, 10), parseInt(month, 10) - 1, parseInt(day, 10), 12, 0, 0);
  }

  // Return undefined for unexpected formats to avoid timezone-sensitive parsing
  // This helps catch data format issues early rather than silently misinterpreting dates
  console.warn('[parseMemberDateOfBirthForPicker] Unexpected date format:', dateString);
  return undefined;
};

export default parseMemberDateOfBirthForPicker;
